define('modules/editor/models/property_groups/idclass',['require','exports','module','./base','../editorstate'],function(require,exports,module){
  "use strict";
  var BasePropertyGroup = require("./base"),
      EditorState = require("../editorstate");

  module.exports = BasePropertyGroup.extend({
    set: function() {
      // overwrite set because it's critical to call _ensureId
      // after every set to make sure we have an ID. Going with
      // a listener would be fragile if someone .sets with
      // {silent: true}
      module.exports.__super__.set.apply(this, arguments);
      this._ensureId(module.exports.__super__.set);
    },
    _ensureId: function(setFn) {
      var id = this.get("id");
      if (!id) {
        if(EditorState.getVariant() && this.parent){
          var elementName = "lpg-" + this.parent.defaultNameKey + "-" + EditorState.getUniqueId();
          if (EditorState.getVariant().getElementById(elementName)) {
            this._ensureId(setFn);
          } else {
            setFn.call(this, { id:  elementName });
          }
        }
        else {
          //old random method
          setFn.call(this, {id: "id-" + Math.random().toString(36).slice(2)});
        }
      }
    },
    name: "idclass",
    properties: [
      "id",
      "className"
    ],
    defaults: {
      "id": "",
      "className": ""
    },
    applyStyles: function($el){
      $el.attr("id", this.get("id"));
      //remove old classes
      var oldClass = this.previousAttributes().className;
      if(oldClass){
        $el.removeClass(oldClass);
      }
      $el.addClass(this.get("className"));
    },
    validators: {
      id: function(attrs) {
        return attrs.id === this.get("id") || !EditorState.getVariant().getElementById(attrs.id);
      }
    }
  });
});

